import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Spinner, Modal } from "reactstrap";
// import rButton from "reactstrap/button";

import {
  deleteRequest,
  putRequest,
  postRequest,
  putRequestForm,
  RBButton,
  deleteConfirmationWords,
} from "components/Common/Utils";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { format } from "date-fns";
// import StarComponent from "./StarComponent";

import Lightbox from "react-image-lightbox";

import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Avatar,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

import LocationPicker from "react-location-picker";
// import DayTimePicker from "./DayTimePicker";

import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./CustomCard.css";
import FavouriteTable from "./FavouriteTable";
import UserRatingTable from "./UserRatingTable";
import BookingTable from "./BookingTable";
import ProductesTable from "./ProductesTable";
import ManufactureDocument from "./ManufactureDocument";

export default function Manufacturedetails() {
  const _id = useParams();
  const location = useLocation();
  const state = location.state?.row;
  const [userAllDetails, setuserAllDetails] = useState({});
  const [loader, setLoader] = useState(false);
  const [imageLB, setImage] = React.useState("");
  const [images, setImages] = React.useState([]);
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [CMshow, setCMshow] = useState(false);
  const [kuliesCommValue, setKuliesCommValue] = useState(0);
  const [kuliesComm, setKuliesComm] = useState({});
  const [comValidation, setComValidation] = useState('');
  const [paymentType, setPaymentType] = useState('');
  const [deliveryType, setDeliveryType] = useState('');
  const [creditDays, setCreditDays] = useState(0);
  const [type, setType] = useState('');

  const useStyles = makeStyles({
    tableHeader: {
      color: "#ffffff", // Use your preferred color
      backgroundColor: "#3f51b5", // Header background color
      fontWeight: "bold",
    },
    descriptionText: {
      fontSize: "0.8rem",
    },
    deleteIcon: {
      color: "red",
    },
    roundImage: {
      borderRadius: "50%",
      width: "75px",
      height: "75px",
    },
    roundImageSm: {
      borderRadius: "50%",
    },

    gridList: {
      width: "100%",
    },
    icon: {
      color: "rgba(255, 55, 25, 0.54)",
    },
  });

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };


  useEffect(() => {
    fetchDetails();
  }, [_id]);

  const fetchDetails = async () => {
    setLoader(true);
    const payload = {
      manufactureId: _id?.id
    };
    try {
      const response = await postRequest(`manufacture/find-By-Id`, payload);
      const data = response.data;
      setuserAllDetails(data);
      setCreditDays(data?.creditDays);
      setPaymentType(data?.type);
      setDeliveryType(data?.deliveryTerms);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const CMtoggleModel = (item, type) => {
    setCMshow(true);
    setKuliesComm(item);
    console.log(type);
    setType(type);
  };

  ///payment
  const handlePaymentTypeChange = (e) => {
    const selectedType = e.target.value;
    setPaymentType(selectedType);
  };
  //delivery
  const handleDeliveryTypeChange = (e) => {
    const selectedType = e.target.value;
    setDeliveryType(selectedType);
  };

  const handleCreditDaysChange = (e) => {
    setCreditDays(e.target.value);
  };

  const callUpdateTypeApi = async (data) => {
    try {
      let payload = { manufactureId: userAllDetails?._id };
      if (type === "type") {
        payload = {
          ...payload,
          type: data.type,
          creditDays: data.creditDays,
        };
      } else if (type === "deliveryTerms") {
        payload = {
          ...payload,
          deliveryTerms: deliveryType,
        };
      }
      const response = await postRequest('manufacture/update-type', payload);
      if (response?.status) {
        toast.success(response?.message);
        fetchDetails();
        setTimeout(() => {
          setCMshow(false);
        }, 500);
      } else {
        toast.warning(response?.message);
      }
    } catch (error) {
      console.error('Error calling API:', error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (paymentType === 'postpaid') {
      callUpdateTypeApi({ type: paymentType, creditDays });
    } else {
      callUpdateTypeApi({ type: paymentType });
    }
  };

  return (
    <>
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>User Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">User Management</li>:{" "}
              <li className="breadcrumb-item">Manufacturer details</li>
            </ol>
          </div>
        </Col>
        <div className="col-md-2 text-end">
          <button
            type="button"
            class="btn btn-primary btn-lg"
            onClick={() => history.back()}
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>

        {loader ? (
          <CardBody style={{ height: "100px" }}>
            <Spinner
              color="info"
              style={{
                height: "4rem",
                width: "4rem",
                position: "absolute",
                left: "50%",
              }}
            >
              Loading...
            </Spinner>
          </CardBody>
        ) : (
          <>
            <Card className="custom-card">
              {/* <div className="carousel-wrapper">

      <Carousel 
        autoPlay 
        infiniteLoop 
        showThumbs={false} 
        showStatus={false} 
        emulateTouch 
        dynamicHeight 
      >
        {images?.map((image, index) => (
          <div 
            key={index} 
            className="cover-image"
            style={{ 
              backgroundImage: `url(${image})`,  
            }}
          >
       
          </div>
        ))}
      </Carousel>
    </div> */}

              <div
                className="cover-image"
                style={{ backgroundColor: "rgb(29, 155, 240)" }}
              ></div>

              <div className="profile-image">
                <img
                  src={
                    userAllDetails?.logo
                      ? userAllDetails?.logo
                      : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.companyName
                      }`
                  }
                  onClick={() =>
                    showLightBox(
                      userAllDetails?.logo
                        ? userAllDetails?.logo
                        : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.companyName
                        }`
                    )
                  }
                  alt="Image Not Available"
                />
              </div>
              <br></br>

              <div className="row my-2 py-2">
                <div
                  className="userinfo col-md-12 "
                  style={{ paddingLeft: "20px" }}
                >
                  <div className="fst">
                    {" "}
                    <h3 className="mt-2"> {userAllDetails?.companyName} </h3>{" "}
                  </div>
                  <div className="row align-items-end">
                    <div className="col-md-4 mt-2 fst py-1">
                      {" "}
                      <img
                        width={'70px'}
                        src={
                          userAllDetails?.images?.[0]
                            ? userAllDetails?.images?.[0]
                            : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.first_name + " " + userAllDetails?.last_name
                            }`
                        }
                        onClick={() =>
                          showLightBox(
                            userAllDetails?.images?.[0]
                              ? userAllDetails?.images?.[0]
                              : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.first_name + " " + userAllDetails?.last_name
                              }`
                          )
                        }
                        alt="Image Not Available"
                      />
                      <p>
                        {" "}
                        Owner Name : <span> {userAllDetails?.first_name + " " + userAllDetails?.last_name} </span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Email: <span>{userAllDetails?.email}</span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        mobile: <span> {userAllDetails?.mobile} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Gender: <span> {userAllDetails?.gender} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Country: <span> {userAllDetails?.country} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Country Code: <span> {userAllDetails?.country_code} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      <p>
                        {" "}
                        Created At:
                        <span> {formatDate(userAllDetails?.createdAt)}</span>
                      </p>
                    </div>
                    <div className="col-md-4 fst py-1">
                      <p>
                        {" "}
                        Payment Terms :
                        <span className="text-capitalize"> {userAllDetails?.type} &nbsp;&nbsp;
                          <button type="button" onClick={() => CMtoggleModel(userAllDetails, 'type')} className="btn btn-primary" style={{ padding: '2px 7px' }}>
                            <i className="fal fa-edit" />
                          </button></span>
                      </p>
                      {userAllDetails?.type === 'postpaid' &&
                        <p>
                          {" "}
                          Credit Period (Days)
                          <span className="text-capitalize"> {userAllDetails?.creditDays} </span>
                        </p>}
                    </div>
                      <div className="col-md-4 fst py-1">
                        <p>
                        {" "}
                        Delivery Terms : 
                        <span className="text-capitalize"> {userAllDetails?.deliveryTerms} &nbsp;&nbsp;
                          <button type="button" onClick={() => CMtoggleModel(userAllDetails, 'deliveryTerms')} className="btn btn-primary" style={{ padding: '2px 7px' }}>
                            <i className="fal fa-edit" />
                          </button></span>
                      </p>
                      </div>
                  </div>
                </div>
              </div>
            </Card>

            <Col md="12">
              <div
                id="exTab2"
                className="twitter-like-tabs2"
                style={{ background: "#ffff", marginLeft: "25px" }}
              >
                <ul
                  className="nav nav-pills"
                  style={{ width: "480px", display: "contents" }}
                >
                  <li className="active">
                    <a href="#bookings" data-toggle="tab">
                      {" "}
                      Products{" "}
                    </a>
                  </li>

                  <li>
                    <a href="#Documents" data-toggle="tab">
                      {" "}
                      Documents{" "}
                    </a>
                  </li>

                  {/* <li>
                    <a href="#favorite" data-toggle="tab">
                      {" "}
                      Favorite{" "}
                    </a>
                  </li> */}
                </ul>
              </div>
            </Col>
            <Col md="12">
              <div className="tab-content clearfix">
                <div className="tab-pane active show padded-tab" id="bookings">
                  {userAllDetails?.intCode !== 0 && (
                    <ProductesTable userId={userAllDetails._id} />
                    // <BookingTable userId={userAllDetails._id} />
                  )}
                </div>

                <div className="tab-pane padded-tab" id="Documents">
                  {userAllDetails?.document && <ManufactureDocument document={userAllDetails?.document} />}
                </div>

                <div className="tab-pane padded-tab" id="favorite">
                  {userAllDetails?.intCode !== 0 &&
                    ""
                    // <FavouriteTable userId={userAllDetails._id} />
                  }
                </div>
              </div>
            </Col>
          </>
        )}

        <Modal
          isOpen={CMshow}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered={true}
        >
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="myLargeModalLabel">
               {type == 'type' ? <>Payment Type</> : <>Delivery Terms</>} 
              </h5>
              <button
                onClick={() => setCMshow(false)}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="product-item">
              {type == 'type' ?
                <div className="product-info" style={{ width: '100%' }}>
                  <h5>{kuliesComm?.name}</h5>
                  <div className="manufacturedetail">
                    <div className="logo-manufacturedetail"> <img src={kuliesComm?.logo} /></div>
                    {kuliesComm?.companyName} <br />
                    {kuliesComm?.address}
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <div style={{width : '50%'}}>
                      <label className="mb-0">Payment Type</label>
                      <select
                        className="form-control"
                        value={paymentType}
                        onChange={handlePaymentTypeChange}
                      >
                        <option disabled value="">
                          Please Select
                        </option>
                        <option value="postpaid">Postpaid</option>
                        <option value="prepaid">Prepaid</option>
                      </select>
                    </div>

                    {paymentType === 'postpaid' && (
                      <div style={{width : '50%'}}>
                        <label className="mb-0">Credit Days</label>
                        <input
                          type="number"
                          className="form-control"
                          value={creditDays}
                          onChange={handleCreditDaysChange}
                          placeholder="Enter Credit Days"
                        />
                      </div>
                    )}
                  </div>
                </div>
             : <>
              <div className="product-info" style={{ width: '100%' }}>
                  <h5>{kuliesComm?.name}</h5>
                  <div className="manufacturedetail">
                    <div className="logo-manufacturedetail"> <img src={kuliesComm?.logo} /></div>
                    {kuliesComm?.companyName} <br />
                    {kuliesComm?.address}
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <div style={{width : '50%'}}>
                      <label className="mb-0">Delivery Type</label>
                      <select
                        className="form-control"
                        value={deliveryType}
                        onChange={handleDeliveryTypeChange}>
                        <option disabled value="">
                          Please Select
                        </option>
                        <option value="self">Self Pickup</option>
                        <option value="assign">Assign Delivery</option>
                      </select>
                    </div>
                  </div>
                </div>
             </>
             }
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-danger" onClick={() => setCMshow(false)}>
                Cancel
              </button>
              <button type="submit" className="btn btn-info">
                Save
              </button>
            </div>
          </form>
        </Modal>

        {openLightbox && (
          <Lightbox
            mainSrc={imageLB}
            onCloseRequest={() => setOpenLightBox(false)}
          />
        )}
      </Row>
      <ToastContainer />{" "}
    </>
  );
}
